import { render } from "./IntroShapes.vue?vue&type=template&id=3f62d20e"
import script from "./IntroShapes.vue?vue&type=script&lang=js"
export * from "./IntroShapes.vue?vue&type=script&lang=js"

import "./IntroShapes.vue?vue&type=style&index=0&id=3f62d20e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__